import { Component } from '@angular/core';
import { IToolPanelAngularComp } from '@ag-grid-community/angular';
import { IToolPanelParams } from '@ag-grid-community/core';
import { Helper, SharedFacade } from '@piqet-angular/data';

@Component({
  selector: 'piqet-angular-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements IToolPanelAngularComp {
  gridApi: any;
  gridName: any;
  columnApi: any;
  gridConfig: any = [];

  constructor(private sharedFacade: SharedFacade) {}

  refresh(params: IToolPanelParams): boolean {
    return false;
  }

  agInit(params: any): void {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridName = params.gridName;
    this.gridConfig = params.gridConfig;
  }

  saveView() {
    const columnState = this.columnApi.getColumnState();
    //let allColumns : any;
    const allColumns = this.columnApi.getColumns().map((column: any) => column.getColDef());
    const columns = columnState
      .filter((state: any) => state.colId !== 'ag-Grid-AutoColumn')
      .map((state: any) => ({
        ...allColumns.find((column: any) => column.colId === state.colId),
        rowGroup: state.rowGroup,
        hide: state.hide,
      }));

    // don't save filter toggle while saving state
    columns.map((column: any) => {
      if (column.filter) {
        column.floatingFilter = true;
      }
    });

    const obj = {
      ...Helper.getGridConfigs(),
      jsonConfiguration: JSON.stringify(columns),
    };
    this.sharedFacade.updateGridState(obj);
    this.gridApi.closeToolPanel();
  }
}
